import pricings from "./pricings.component";
import pricingsUrls from "./pricings.urls";
import PricingsTransforms from "./pricings.transforms";

const pricingsModule = angular
  .module("app.components.pricings", [])
  .component("pricingsPage", pricings)
  .service("PricingsTransforms", PricingsTransforms)
  .config(pricingsUrls);

export default pricingsModule;



// WEBPACK FOOTER //
// ./src/pages/pricings/pricings.module.js